import moment from "moment";
import { v4 as uuidv4 } from "uuid";

export function convertToEvents(t, data, type, color) {
  return data.map((item) => {
    const date = moment(item.data).set({ hour: 8, minute: 0, second: 0 });
    const startLocal = date.clone().toDate();
    const endLocal = date
      .clone()
      .set({ hour: 20, minute: 0, second: 0 })
      .toDate();

    return {
      id: uuidv4(),
      title: item.obs,
      start: startLocal,
      end: endLocal,
      allDay: true,
      type: type,
      color: color,
    };
  });
}

export function convertToEventsFolgas(t, data, type, color) {
  const offsetMs = new Date().getTimezoneOffset() * 60 * 1000;

  return data.map((item) => {
    const date = moment(item).set({ hour: 8, minute: 0, second: 0 });
    return {
      id: uuidv4(),
      title: t("portalrh.workDays.folgas"),
      start: new Date(date.toDate().getTime() - offsetMs),
      end: new Date(
        date.clone().set({ hour: 20 }).toDate().getTime() - offsetMs
      ),
      type,
      color,
    };
  });
}

export function convertToEventsDiasMarcados(
  t,
  data,
  type,
  color,
  marcacao,
  daytoRemove,
  feriasPendentesMap
) {
  const feriasPendentesSet = new Set();
  if (feriasPendentesMap && typeof feriasPendentesMap === "object") {
    Object.values(feriasPendentesMap).forEach(
      ({ tipo, estado, FEM_DATA_INICIO, FEM_DATA_FIM }) => {
        if (tipo === "Apagar" && estado === "1") {
          for (
            let m = moment(FEM_DATA_INICIO);
            m.isSameOrBefore(FEM_DATA_FIM, "day");
            m.add(1, "days")
          ) {
            feriasPendentesSet.add(m.format("YYYY-MM-DD"));
          }
        }
      }
    );
  }

  return data
    .map((item) => {
      if (feriasPendentesSet.has(item)) return null;

      const date = moment(item).set({ hour: 8, minute: 0, second: 0 });
      const offsetMs = new Date().getTimezoneOffset() * 60 * 1000;
      const start = new Date(date.toDate().getTime() - offsetMs);
      const end = new Date(
        date.clone().set({ hour: 20 }).toDate().getTime() - offsetMs
      );

      let idToSelect = null,
        marcacaoPedido = {},
        parte = "0";
      if (Array.isArray(marcacao)) {
        marcacao.forEach(({ dataInicio, dataFim, idpedido, parteDia }) => {
          if (
            date.isBetween(moment(dataInicio), moment(dataFim), "day", "[]")
          ) {
            idToSelect = idpedido;
            marcacaoPedido = { dataInicio, dataFim, idpedido, parteDia };
            parte = parteDia;
          }
        });
      }

      return {
        id: uuidv4(),
        title: t("portalrh.workDays.ferias"),
        start,
        end,
        type,
        color,
        idToSelect,
        marcacaoPedidoEvent: marcacaoPedido,
        daytoRemove,
        parteDia: parte,
        empConsumoSaldo: "0",
      };
    })
    .filter(Boolean);
}

export function convertToEventsDiasGozados(
  t,
  data,
  type,
  color,
  marcacao,
  feriasPendentesMap
) {
  const feriasPendentesSet = new Set(
    Object.values(feriasPendentesMap || {})
      .filter((marc) => marc.tipo === "Apagar" && marc.estado === "1")
      .map((marc) => marc.FEM_DATA_INICIO)
  );

  return data
    .map((item) => {
      const date = moment(item).set({ hour: 8, minute: 0, second: 0 });
      const startLocal = new Date(
        date.toDate().getTime() - new Date().getTimezoneOffset() * 60 * 1000
      );
      const endLocal = new Date(
        date
          .clone()
          .set({ hour: 20, minute: 0, second: 0 })
          .toDate()
          .getTime() -
          new Date().getTimezoneOffset() * 60 * 1000
      );

      if (feriasPendentesSet.has(item)) return null;

      const marcacaoPedido =
        marcacao?.find((marc) =>
          date.isBetween(
            moment(marc.dataInicio),
            moment(marc.dataFim),
            "day",
            "[]"
          )
        ) || {};
      const idToSelect = marcacaoPedido.idpedido || null;
      const parte = marcacaoPedido.parteDia || "0";

      return {
        id: uuidv4(),
        title: t("portalrh.workDays.diasGozados"),
        start: startLocal,
        end: endLocal,
        type: type,
        color: color,
        idToSelect: idToSelect,
        marcacaoPedidoEvent: marcacaoPedido,
        parteDia: parte,
      };
    })
    .filter((event) => event !== null);
}

export function convertToEventsDiasPendentes(
  t,
  data,
  type,
  color,
  feriasPendentesMap
) {
  if (feriasPendentesMap && typeof feriasPendentesMap === "object") {
    Object.values(feriasPendentesMap).forEach(
      ({ tipo, estado, FEM_DATA_INICIO, FEM_DATA_FIM }) => {
        if (tipo === "Apagar" && estado === "1") {
          for (
            let m = moment(FEM_DATA_INICIO);
            m.isSameOrBefore(FEM_DATA_FIM, "day");
            m.add(1, "days")
          ) {
            const dateStr = m.format("YYYY-MM-DD");
            if (!data.includes(dateStr)) data.push(dateStr);
          }
        }
      }
    );
  }

  const offsetMs = new Date().getTimezoneOffset() * 60 * 1000;

  return data.map((item) => {
    const date = moment(item).set({ hour: 8, minute: 0, second: 0 });
    const start = new Date(date.toDate().getTime() - offsetMs);
    const end = new Date(
      date.clone().set({ hour: 20 }).toDate().getTime() - offsetMs
    );

    let idToSelect = null,
      marcacaoPedido = {},
      parte = "0",
      toCancel = false;

    if (feriasPendentesMap && typeof feriasPendentesMap === "object") {
      Object.values(feriasPendentesMap).forEach(
        ({
          FEM_DATA_INICIO,
          FEM_DATA_FIM,
          pedId,
          FEM_PARTE_DIA,
          tipo,
          estado,
        }) => {
          if (
            date.isBetween(
              moment(FEM_DATA_INICIO),
              moment(FEM_DATA_FIM),
              "day",
              "[]"
            )
          ) {
            idToSelect = pedId;
            marcacaoPedido = {
              FEM_DATA_INICIO,
              FEM_DATA_FIM,
              pedId,
              FEM_PARTE_DIA,
            };
            parte = FEM_PARTE_DIA;
            toCancel = tipo === "Apagar" && estado === "1";
          }
        }
      );
    }

    return {
      id: uuidv4(),
      title: t(
        toCancel
          ? "portalrh.workDays.feriasToCancel"
          : "portalrh.workDays.feriasPendentes"
      ),
      start,
      end,
      type,
      color: toCancel ? "#F8B4B4" : color,
      idToSelect,
      marcacaoPedidoEvent: marcacaoPedido,
      daytoRemove: true,
      parteDia: parte,
      empConsumoSaldo: "0",
      toCancel,
    };
  });
}

export function convertToEventsDiasMarcadosTeamEmployee(t, data, type) {
  return data.map((item) => {
    const date = moment(item.data.date).set({ hour: 8, minute: 0, second: 0 });
    const startLocal = new Date(
      date.toDate().getTime() - new Date().getTimezoneOffset() * 60 * 1000
    );
    const endLocal = new Date(
      date.clone().set({ hour: 20, minute: 0, second: 0 }).toDate().getTime() -
        new Date().getTimezoneOffset() * 60 * 1000
    );
    const stateColors = { 1: "goldenrod", 2: "red", 3: "green" };
    const color = stateColors[item.data.state] || item.color;
    return {
      id: uuidv4(),
      title: item.nome,
      start: startLocal,
      end: endLocal,
      type: type,
      color: color,
      state: parseInt(item.data.state),
      name: item.nome,
      userId: item.userId,
    };
  });
}

export function convertToEventsDiasMarcadosTeam(t, data, type) {
  const offsetMs = new Date().getTimezoneOffset() * 60 * 1000;

  return data.map((item) => {
    if (item.entries !== undefined) {
      const dateObj = moment(item.data).set({ hour: 8, minute: 0, second: 0 });
      return {
        id: uuidv4(),
        title: item.data,
        start: new Date(dateObj.toDate().getTime() - offsetMs),
        end: new Date(
          dateObj.clone().set({ hour: 20 }).toDate().getTime() - offsetMs
        ),
        type,
        color: item.color,
        entries: item.entries,
        name: `${t("portalrh.workDays.feriasTranslated.entriesDetail1")} ${
          item.entries
        } pessoas ${t("portalrh.workDays.feriasTranslated.entriesDetail2")}`,
      };
    } else {
      const { date, state, meioDia } = item.data;
      const dateObj = moment(date).set({ hour: 8, minute: 0, second: 0 });
      return {
        id: uuidv4(),
        title: item.nome,
        start: new Date(dateObj.toDate().getTime() - offsetMs),
        end: new Date(
          dateObj.clone().set({ hour: 20 }).toDate().getTime() - offsetMs
        ),
        type,
        color: item.color,
        state: parseInt(state),
        name: item.nome,
        meioDia,
        userId: item.userId,
      };
    }
  });
}

export function convertToEventsMarkedDays(t, data, type, color) {
  const offsetMs = new Date().getTimezoneOffset() * 60 * 1000;

  return data.map((item) => {
    const date = moment(item).set({ hour: 8, minute: 0, second: 0 });
    const startLocal = new Date(date.toDate().getTime() - offsetMs);
    const endLocal = new Date(
      date.clone().set({ hour: 20, minute: 0, second: 0 }).toDate().getTime() -
        offsetMs
    );

    return {
      id: uuidv4(),
      title: t("portalrh.workDays.selectedDay"),
      start: startLocal,
      end: endLocal,
      type: type,
      color: color,
      checked: true,
      checkedHalfDay: false,
      multi: true,
      parteDia: "0",
      empConsumoSaldo: "0",
    };
  });
}

export function convertToEventsMarkedDaysToApprove(t, data, type, color) {
  const offsetMs = new Date().getTimezoneOffset() * 60 * 1000;

  return data.dates.map((item) => {
    const date = moment(item).set({ hour: 8, minute: 0, second: 0 });
    return {
      id: uuidv4(),
      title: t("portalrh.workDays.selectedDay"),
      start: new Date(date.toDate().getTime() - offsetMs),
      end: new Date(
        date.clone().set({ hour: 20 }).toDate().getTime() - offsetMs
      ),
      type,
      color,
      checked: true,
      checkedHalfDay: false,
      multi: true,
      parteDia: "0",
      empConsumoSaldo: "0",
    };
  });
}

export const getMonthRange = (selectedDate) => {
  const start = moment(selectedDate).startOf("month").toDate();
  const end = moment(selectedDate).endOf("month").toDate();
  return { start, end };
};

export const isDisabled = (eventsTemp, marcacaoFeriasCalendario) => {
  const hasEmpConsumoSaldoZeroOrTwo = eventsTemp.some(
    (event) => event.empConsumoSaldo === "0" || event.empConsumoSaldo === "2"
  );

  const hasEmpConsumoSaldoOne = eventsTemp.some(
    (event) => event.empConsumoSaldo === "1"
  );

  const hasUncheckedHalfDay = eventsTemp.some(
    (event) => event.checkedHalfDay === false
  );

  const noSaldoAndEmpConsumoSaldoZeroOrTwo =
    marcacaoFeriasCalendario.sPendente === 0 && hasEmpConsumoSaldoZeroOrTwo;
  const halfDayNotCheckedAndEmpConsumoSaldoZeroOrTwo =
    marcacaoFeriasCalendario.sPendente === 0.5 &&
    hasUncheckedHalfDay &&
    hasEmpConsumoSaldoZeroOrTwo;
  const noSaldoAnoAntAndEmpConsumoSaldoOne =
    marcacaoFeriasCalendario.sPendenteAnoAnt === 0 && hasEmpConsumoSaldoOne;
  const noChoosedHalfDay = eventsTemp.some(
    (event) => event.checkedHalfDay === true && event.parteDia === "0"
  );

  const isDisabled =
    noSaldoAndEmpConsumoSaldoZeroOrTwo ||
    halfDayNotCheckedAndEmpConsumoSaldoZeroOrTwo ||
    noSaldoAnoAntAndEmpConsumoSaldoOne ||
    noChoosedHalfDay ||
    eventsTemp.length < 1;

  return isDisabled;
};

export const generateCalendarData = (vacations, loadNewDateSelected) => {
  const months = moment.months();
  const daysInMonth = (month, year) => new Date(year, month, 0).getDate();
  const year = loadNewDateSelected.getFullYear();
  const calendar = [];

  for (let month = 0; month < 12; month++) {
    const days = daysInMonth(month + 1, year);
    const monthData = [];

    Object.values(vacations).forEach((vacation) => {
      if (vacation.user && vacation.user.nome) {
        let fullName = vacation.user.nome;
        const personData = {
          name: fullName,
          days: Array.from({ length: days }, (_, day) => {
            const date = `${year}-${String(month + 1).padStart(
              2,
              "0"
            )}-${String(day + 1).padStart(2, "0")}`;

            const isHoliday = vacation.feriados.some((v) => v.data === date);
            const isVacationApproved = vacation.feriasAprovadas.some((v) =>
              v.startsWith(date)
            );
            const isVacationGozado = vacation.feriasGozadas.some((v) =>
              v.startsWith(date)
            );
            const isVacationsPending = vacation.feriasPendentes.some((v) =>
              v.startsWith(date)
            );
            const isDayOff = vacation.folgas.includes(date);

            return {
              date,
              isHoliday,
              isVacationApproved,
              isVacationGozado,
              isDayOff,
              isVacationsPending,
            };
          }),
        };
        monthData.push(personData);
      }
    });

    calendar.push({
      month: months[month],
      days: monthData,
    });
  }

  return calendar;
};

export const eventosDoDia = (date, events) => {
  return events.filter(
    (evento) =>
      evento.start.getDate() === date.getDate() &&
      evento.start.getMonth() === date.getMonth() &&
      evento.start.getFullYear() === date.getFullYear()
  );
};

  const formatDateSaveWorkDays = (date) => {
    return new Date(date)
      .toLocaleDateString("en-GB", {
        timeZone: "Europe/Lisbon",
      })
      .split("/")
      .reverse()
      .join("-");
  };

export const getEventsToCreate = (eventsTemp) => {
  let feriasmarkedDays = [];
  let intervalsDays = [];

  eventsTemp.forEach((event) => {
    const eventDates = [formatDateSaveWorkDays(event.start)];

    if (event.type === "feriasmarked") {
      feriasmarkedDays.push({
        data: eventDates,
        meioDia: event.checkedHalfDay,
        parteDia: event.parteDia,
        anoAnterior: event.empConsumoSaldo,
      });
    }

    if (event.type === "intervals") {
      const allIntervalDates = Array.isArray(event.intervals)
        ? [formatDateSaveWorkDays(event.start), ...event.intervals]
        : [formatDateSaveWorkDays(event.start)];

      const existingInterval = intervalsDays.find((intervalEvent) =>
        intervalEvent.data.some((date) => allIntervalDates.includes(date))
      );

      if (existingInterval) {
        existingInterval.data = [
          ...new Set([...existingInterval.data, ...allIntervalDates]),
        ];
      } else {
        intervalsDays.push({
          data: allIntervalDates,
          meioDia: event.checkedHalfDay,
          parteDia: event.parteDia,
          anoAnterior: event.empConsumoSaldo,
        });
      }
    }
  });

  return [...feriasmarkedDays, ...intervalsDays];
};
